export default __webpack_public_path__ + "static/media/wolf.1702612e.jpg";